import styled from '@emotion/styled'
import { color, fontSize, space, Alert } from '@ticketswap/solar'
import PropTypes from '~/lib/propTypes'
import { useContext, useEffect, useState } from 'react'
import { FacebookContext } from '~/components/FacebookContext'
import { getCookie } from 'cookies-next'

const Label = styled.p`
  text-align: center;
  margin-block-end: ${space[16]};
  font-size: ${fontSize[16]};
  color: ${color.foreground};
`

const StyledAlert = styled(Alert)`
  margin-block-end: ${space[16]};
`

const LastLoginMethod = ({ t }) => {
  const [facebookNotAvailable, setFacebookNotAvailable] = useState(false)
  const { isInitialized } = useContext(FacebookContext)

  useEffect(() => {
    if (isInitialized) {
      setFacebookNotAvailable(false)
    }

    const timer = setTimeout(() => {
      if (!isInitialized) {
        setFacebookNotAvailable(true)
      }
    }, 3000)

    return () => {
      clearTimeout(timer)
    }
  }, [isInitialized])

  const method = getCookie('lastLoginMethod')
  const incorrectLoginMethod = !['facebook', 'apple', 'email', 'google', 'code'].includes(method)

  if (incorrectLoginMethod) return null

  if (method === 'facebook' && facebookNotAvailable) {
    return <StyledAlert variant="warning">{t('common:auth.login.facebookUnavailable')}</StyledAlert>
  }

  if (method === 'facebook') {
    return <Label>{t('common:auth.login.method.facebook')}</Label>
  }

  if (method === 'apple') {
    return <Label>{t('common:auth.login.method.apple')}</Label>
  }

  if (method === 'google') {
    return <Label>{t('common:auth.login.method.google')}</Label>
  }

  return <Label>{t('common:auth.login.method.email')}</Label>
}

LastLoginMethod.propTypes = {
  t: PropTypes.func.isRequired,
}

export default LastLoginMethod
